import type { Locale } from "../stores/locale-store";

export const bookingLocale = (locale: Locale) => locale === "sv" ? "sv-SE" : "en-GB";

/** Booking dates are Stockholm calendar dates, not UTC timestamps. */
export function formatBookingDate(date: string, locale: Locale, compact = false): string {
  const value = new Date(`${date.slice(0, 10)}T12:00:00Z`);
  return new Intl.DateTimeFormat(bookingLocale(locale), {
    timeZone: "Europe/Stockholm", weekday: compact ? "short" : "long",
    day: "numeric", month: compact ? "short" : "long", year: "numeric",
  }).format(value);
}

export function bookingTimeZone(date: string): string {
  return new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Stockholm", timeZoneName: "short" })
    .formatToParts(new Date(`${date.slice(0, 10)}T12:00:00Z`))
    .find(part => part.type === "timeZoneName")?.value || "Europe/Stockholm";
}

export function formatBookingAmount(amount: number, locale: Locale): string {
  return amount.toLocaleString(bookingLocale(locale));
}
